import { toast } from "react-toastify";
import { push } from "connected-react-router";

import paths from "routes/paths";
import UserActioner from "services/user/actioner";
import AuthenticationApi from "./api";
import IntlUtils from "services/intl/utils";
import AuthenticationActionTypes from "./types";

class AuthenticationActioner {
  static setAuth(auth) {
    return {
      type: AuthenticationActionTypes.SET_AUTH,
      ...auth,
    };
  }

  static logout() {
    return (dispatch) => {
      dispatch({
        type: AuthenticationActionTypes.LOG_OUT,
      });
      dispatch(push(paths.front.login));
    };
  }

  static removeError() {
    return {
      type: AuthenticationActionTypes.REMOVE_ERROR,
    };
  }

  static refreshAuthentication = (authentication) => {
    return (dispatch) => {
      return AuthenticationApi.refreshAuthentication(authentication)
        .then((auth) => {
          dispatch(AuthenticationActioner.setAuth(auth));
          return Promise.resolve(auth);
        })
        .catch((res) => {
          dispatch(AuthenticationActioner.logout());
          return Promise.reject(res);
        });
    };
  };

  static setAuthFromCredentials(credentials) {
    return (dispatch, getState) => {
      return AuthenticationApi.getAuthFromCredentials(credentials)
        .then((auth) => {
          dispatch(
            AuthenticationActioner.setAuth({
              ...auth,
              keepLoggedIn: credentials.keepLoggedIn,
            })
          );
          dispatch(
            UserActioner.setUser({
              user: auth.user,
            })
          );
          return dispatch(UserActioner.initContract()).then(() => {
            return getState().User;
          });
        })
        .catch((error) => {
          const intl = IntlUtils.getIntlInstance();

          let msg = intl.messages["toast.errors.errorOccured"];
          if (error.status === 401) {
            msg = intl.messages["toast.errors.wrongCreds"];
          } else if (error.status === 503) {
            msg = intl.messages["toast.errors.errorOccuredContactSupport"];
          }

          toast(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.ERROR,
          });

          return Promise.reject(error);
        });
    };
  }

  static setAuthFromSSO(code) {
    return (dispatch, getState) => {
      return AuthenticationApi.ssoAuth(code)
        .then((auth) => {
          dispatch(
            AuthenticationActioner.setAuth({
              ...auth,
              keepLoggedIn: true,
            })
          );
          dispatch(
            UserActioner.setUser({
              user: auth.user,
            })
          );
          return dispatch(UserActioner.initContract()).then(() => {
            return getState().User;
          });
        })
        .catch((error) => {
          const intl = IntlUtils.getIntlInstance();

          let msg = intl.messages["toast.errors.errorOccured"];
          if (error.status === 401) {
            msg = intl.messages["toast.errors.wrongCreds"];
          } else if (error.status === 503) {
            msg = intl.messages["toast.errors.errorOccuredContactSupport"];
          }

          toast(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.ERROR,
          });
        });
    };
  }
}

export default AuthenticationActioner;
